import './src/scss/theme.scss'
import('../../src/js/app')

require('owl.carousel')

$(document).ready(function () {
  $('.hero-slider.owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: false,
    items: 1
  })
  $('.header-usp.owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 3
      },
      800: {
        items: 4
      },
      1000: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  })
})
